// Scene resolution for the BPM TV surface: picks the elevation grid, filters pins/flags,
// and builds the legend object from model state.
//
// Two paths, ported from the legacy chart:
//   mode 'render'    — first draw and every rebuild: the picked entity's or attribute's own legend text.
//   mode 'elevation' — a live pick in the elevation control: the generic entity/attribute legend text,
//                      which the rebuild that follows replaces.
// Both narrow the flags (entity pick) or pins (attribute pick) to what the picked item has means for,
// so a live pick draws what a reload of the same state draws.

import {
  attributeLegendText,
  batchLegendText,
  entityLegendText,
  variantLegendText
} from '@aytm/app/stats/page/question-views/bpm/components/tv/components/chart/lib/tvLegend'

const legend = (title, grid) => ({
  title,
  min: grid.heightMin,
  max: grid.heightMax,
  bricks: grid.heightTicks
})

export const resolveScene = ({
  answer,
  tvPlotByValue,
  tvElevationsRepresentValue,
  defaultValues,
  pins,
  flags,
  questionVariants = [],
  batches = [],
  mode = 'render'
}) => {
  const geoData = answer?.mds?.geoData
  if (!geoData) return null

  if (tvPlotByValue === 'e') {
    let v = Number(tvElevationsRepresentValue)
    if (Number.isNaN(v)) v = Number(defaultValues.e.e)

    const isAll = v === -1
    const grid = geoData.brand[isAll ? 'all' : `qv${v}`]

    const outPins = isAll ? pins : []
    const outFlags = isAll ? flags : flags.filter(el => answer.meanList?.[`qv${v}`]?.[`b${el.branchId}`] != null)
    const title = mode === 'render' && !isAll ? variantLegendText(questionVariants[v - 1]) : entityLegendText(answer)

    return { data: grid.points, pins: outPins, flags: outFlags, legend: legend(title, grid) }
  }

  if (tvPlotByValue === 'a') {
    let v = Number(tvElevationsRepresentValue)
    if (Number.isNaN(v)) v = Number(defaultValues.e.a)

    const isAll = v === -2
    const grid = geoData.attr[isAll ? 'all' : `b${v}`]

    const outFlags = isAll ? flags : []
    const outPins = isAll ? pins : pins.filter(el => answer.meanList?.[`qv${el.questionVariantId}`]?.[`b${v}`] != null)
    const title = mode === 'render' && !isAll ? batchLegendText(batches[v - 1]) : attributeLegendText(answer)

    return { data: grid.points, pins: outPins, flags: outFlags, legend: legend(title, grid) }
  }

  // No plot-by selected: total entity surface (legacy `else` branch L105-112)
  const grid = geoData.brand.all
  return { data: grid.points, pins, flags, legend: legend(entityLegendText(answer), grid) }
}
